import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice = createSlice({
  name: 'dashboardPagination',
  initialState: {
    currentPage: 1,
    listFilter:"assigned-me",
    sortBy: {
      column: "",
      desc: false
    },
    searchKey: "",
    selectedCustomFilter: null, // ⭐ add this
    customFilteredPatients: []
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    resetCurrentPage: (state) => {
      state.currentPage = 1;
    },
    setListFilter: (state, action) => {
      state.listFilter = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setSearchKey: (state, action) => {
      state.searchKey = action.payload;
    },
    setSelectedCustomFilter: (state, action) => {
      state.selectedCustomFilter = action.payload;
    },
    setCustomFilteredPatients: (state, action) => {
      state.customFilteredPatients = action.payload;
    }
  }
});

export const { setCurrentPage, resetCurrentPage,setListFilter,setSortBy,setSearchKey,setSelectedCustomFilter, setCustomFilteredPatients  } = dashboardSlice.actions;
export default dashboardSlice;
